import React from "react"

function UsersChat({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.625 10.5C17.25 10.5 16.125 11.625 16.125 13V16.75V19.25L19.875 17.375H21.75C23.125 17.375 24.25 16.25 24.25 14.875V13C24.25 11.625 23.125 10.5 21.75 10.5H18.625Z"
        stroke="#003E4C"
        strokeWidth="1"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.625 13H20.5"
        stroke="#003E4C"
        strokeWidth="1"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.625 14.875H19.25"
        stroke="#003E4C"
        strokeWidth="1"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.8125 23.375C23.8125 24 24.1875 24.5 24.8125 24.6875C25.5 24.875 26 25.4375 26.1875 26.125H19.9375C20.0625 25.4375 20.625 24.875 21.25 24.6875C21.8125 24.5 22.25 24 22.25 23.375"
        stroke="#003E4C"
        strokeWidth="1"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23 23.625C22.3125 23.625 21.75 23.0625 21.75 22.375V21.125C21.75 20.4375 22.3125 19.875 23 19.875C23.6875 19.875 24.25 20.4375 24.25 21.125V22.375C24.25 23.0625 23.6875 23.625 23 23.625Z"
        stroke="#003E4C"
        strokeWidth="1"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8125 23.375C13.8125 24 14.1875 24.5 14.8125 24.6875C15.5 24.875 16 25.4375 16.1875 26.125H9.875C10 25.4375 10.5625 24.875 11.1875 24.6875C11.75 24.5 12.1875 24 12.1875 23.375"
        stroke="#003E4C"
        strokeWidth="1"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 23.625C12.3125 23.625 11.75 23.0625 11.75 22.375V21.125C11.75 20.4375 12.3125 19.875 13 19.875C13.6875 19.875 14.25 20.4375 14.25 21.125V22.375C14.25 23.0625 13.6875 23.625 13 23.625Z"
        stroke="#003E4C"
        strokeWidth="1"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default UsersChat
